import React from 'react'
import * as PropTypes from 'prop-types'
import withStyles from '@material-ui/core/styles/withStyles'
import i18n from 'support/i18n'
import styles from './View.Style'

const IdeasGrid = (props) => {
  const { classes, children, countSquare, length, customIdeaTitles } = props
  return (
    <div className={classes.container}>
      {countSquare && (
        <div className={classes.countCard}>
          <i className="icon-idea" />
          <h1 style={{ textTransform: "capitalize" }}>
            {
              `${length} ${length === 1
                ? i18n.t('SINGULAR_IDEA', { title: customIdeaTitles.singularTitle || "Idea" })
                : i18n.t('IDEAS', { title: customIdeaTitles.pluralTitle || "Ideas" })}`
            }
          </h1>
        </div>
      )}
      {children}
    </div>
  )
}

IdeasGrid.defaultProps = {
  countSquare: true,
  length: 0,
  customIdeaTitles: {
    singularTitle: "",
    pluralTitle: ""
  }
}

IdeasGrid.propTypes = {
  classes: PropTypes.shape({
    container: PropTypes.string.isRequired,
    countCard: PropTypes.string.isRequired,
  }).isRequired,
  countSquare: PropTypes.bool,
  length: PropTypes.number,
  customIdeaTitles: PropTypes.shape({
    singularTitle: PropTypes.string,
    pluralTitle: PropTypes.string
  })
}

export default withStyles(styles)(IdeasGrid)
